function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Store = function Store(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M9.31 10.49H10v-.01c.45 0 .875-.108 1.25-.3v10.95H4.61V10.489l.09.001v-.01c.44 0 .88-.08 1.3-.23a4.5 4.5 0 0 0 1.236-.704 2.74 2.74 0 0 0 2.074.944M2 21.13h1.11V10.15c-.714-.31-1.26-.804-1.53-1.41-.45-1.01-.04-1.93.24-2.55.26-.58.56-1.13.86-1.66l.16-.29c.183-.338.372-.67.563-1.005l.207-.365.06-.11c.5-.86 1.42-1.4 2.42-1.4h11.35v.01h.47c1 0 1.93.54 2.42 1.4l.06.11c.26.45.52.91.77 1.37l.16.29.105.19c.258.472.526.96.755 1.47l.007.017c.27.61.679 1.532.233 2.533-.264.591-.79 1.076-1.48 1.387V21.13H22c.41 0 .75.34.75.75s-.34.75-.75.75H2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75m17.44 0V10.497l-.14.003v-.01c-.44 0-.88-.08-1.3-.23a4.5 4.5 0 0 1-1.246-.712 2.74 2.74 0 0 1-2.064.932v.01H14a2.74 2.74 0 0 1-1.25-.3v10.94zM11.25 7.742A1.25 1.25 0 0 1 10 8.98h-.69c-.69 0-1.25-.56-1.25-1.25V2.86h3.19v4.882m7.27 1.108c-.378-.137-.749-.383-1.108-.723q.027-.195.028-.397V2.87h.47c.46 0 .89.25 1.12.65l.06.11c.26.44.51.89.76 1.34l.16.29.083.151c.26.475.509.929.717 1.399.29.64.39.99.24 1.33-.21.46-.86.73-1.36.82-.39.07-.79.03-1.17-.11m-5.77-1.11V2.86h3.19v4.87c0 .69-.56 1.25-1.25 1.25H14a1.25 1.25 0 0 1-1.25-1.24M6.09 2.86h.47v4.88q0 .195.026.382-.54.514-1.106.718c-.38.14-.78.18-1.17.11-.5-.09-1.15-.36-1.36-.82-.15-.34-.05-.69.24-1.33.208-.47.457-.924.717-1.399l.083-.151.16-.29c.25-.45.5-.89.76-1.34l.06-.11c.23-.4.66-.65 1.12-.65M9.1 16.21c-.41 0-.75-.34-.75-.75v-1.5c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 .41-.34.75-.75.75m5.08-.75c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
    clipRule: "evenodd"
  }));
};
export default Store;
Store.displayName = 'Store';